<% var phoneNumber = bookingPhoneNumber || I18n.help_phone_number %>

<% if (suggestedSlots.length) { %>
  <% if (showTitle) { %>
    <h2 class="title"><%= desiredProviderSlots.length ? I18n.title.same_provider : I18n.title.new_provider %></h2>
  <% } %>
  <% if (showMessage) { %>
    <% var preamble = I18n.preamble[providerMessageKey][locationMessageKey] %>
    <div class="preamble"><%= preamble.replaceAll('%{original_provider_name}', desiredProvider.name).replaceAll('%{phone_number}', phoneNumber) %></div>
  <% } %>

  <% if (showProviderSelector) { %>
  <div class="field">
    <div class="provider-selector-container"></div>
  </div>
  <% } %>

  <div class="field field--suggestion-selector">
    <div class="suggestion-selector-container"></div>
  </div>
<% } else { %>
  <h2 class="title"><%= I18n.title.no_slots %></h2>

  <div class="text">
    <%= I18n.preamble.no_slots.replaceAll('%{original_provider_name}', desiredProvider.name).replaceAll('%{phone_number}', phoneNumber) %>
  </div>
<% } %>
